export function formatStrapiTemplate(
  template: string | undefined,
  fallback: string,
  vars: Record<string, string | number> = {},
): string {
  let text = template || fallback;
  for (const [key, value] of Object.entries(vars)) {
    text = text.replace(new RegExp(`\\{${key}\\}`, "g"), String(value));
  }
  return text;
}
